export default {
  text: 'Guadagni <highlight>{{value}} punti</highlight> con questo ordine',
};
